import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect} from 'react';
import Props from 'prop-types';
import { post } from '../../../../../../Model/Network/Config/Axios';
import { useSelector } from 'react-redux';


const SearchFilterLayer = forwardRef(({ disabled,  style,onSelect,filterLayer}, ref) => {

    const [suggestion, setSuggestion] = useState([]);
    const [value, setValue] = useState(undefined);
    const {costAllocationFilterData} = useSelector(state=>state.auth.config);
    const costAllocation =  costAllocationFilterData ? costAllocationFilterData[0] : {}
    
    let VALUE=useRef();

    useEffect(()=>{
        if (value && value.length > 0) {
            post(`forms/searchTable/${costAllocation.customTableId}`,{
                searchField:costAllocation.customTableColumn,
                q:value
            },(e,r)=>{
                if(r) {
                    setSuggestion(r.results.map(item=>({
                        name:item[costAllocation.customTableColumn],
                        key:costAllocation.customTableColumn
                    })));
                }
            })
        } else {
            setSuggestion([]);
        }
    },[value])

    const onChange = (e) => {
        filterLayer &&  onSelect(undefined);
        setValue(e.target.value);
    }

    const suggestionList = (item, index) => {
        return (
            <div key={index}
                onClick={() => {
                    setSuggestion([]);
                    if(onSelect) {
                        let obj = {[item.key]:item.name}
                         onSelect(obj)
                    }
                    setValue(item);
                    VALUE.current.value =item.name;
                }}
                className="flex flex-v-center hover"
                style={{
                    height: 45,
                    paddingLeft: 20,
                    cursor: 'pointer',
                    color: 'var(--input-color)',
                }}>
                <div>
                    <p style={{ fontSize: 12 }}>{item.name}</p>
                  {item.description && 
                   <p style={{ fontSize: 12 }}>Description: {item.description}</p>
                   }        
                </div>
            </div>
        )
    }

    useImperativeHandle(ref, () => ({
        getValue: () => {
            return value;
        }
    }));

    if(costAllocationFilterData && !costAllocationFilterData.length>0) 
   return <></>
    return (
        <div style={{
            marginTop: 10,
            ...style
        }}>
            <p style={{
                color: 'var(--title-desc-color)',
                fontSize: 15
            }}>
                Search {(costAllocation && costAllocation.filterKey)||''}
            </p>

            <div style={{
                position: 'relative'
            }}>
                <div className="flex flex-h-center flex-v-center" style={{
                    borderRadius: 8,
                    height: 50,
                    marginTop: 10,
                    cursor: 'pointer',
                    border:'1px solid var(--border-color)'
                }}>
                    <input
                        disabled={disabled}
                        style={{
                            width: '98%',
                            height: '90%',
                            backgroundColor: '#fff',
                            color: 'var(--input-color)',
                            fontSize: 16,
                            padding: '10px 12px',
                            border: 'none'
                        }}
                        ref={VALUE}
                        onChange={onChange}
                        placeholder={`Search ${(costAllocation && costAllocation.filterKey)||''}`}
                    />
                </div>
                {
                    suggestion.length > 0 ?
                        <div style={{
                            position: 'absolute',
                            height: 210,
                            overflowY: 'auto',
                            width: '100%',
                            top: 53,
                            paddingTop: 10,
                            paddingBottom: 10,
                            boxShadow: '0px 0px 5px 1px var(--input-backgroundColor)',
                            zIndex: 10,
                            border:'1px solid var(--border-color)',
                            backgroundColor:'#fff'

                        }}>
                            {suggestion.map(suggestionList)}
                        </div> :
                        null
                }
            </div>
        </div>
    )
})


SearchFilterLayer.propsTypes = {
    type: Props.string
}

SearchFilterLayer.defaultProps = {
    type: 'text',
    placeholder: 'Enter the Text',
}


export {SearchFilterLayer}

export default SearchFilterLayer ;
